import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import axios from 'axios';
import App from './App';
import './index.css';
import '@aws-amplify/ui-react/styles.css';
import { createSwatches } from './services/ColorScaleCreation'

const getConfig = async () =>{
  const config = await axios.get('/config.json')
  Amplify.configure(config?.data?.Amplify);
  return config;
}

const _config = await getConfig();

const params = new URLSearchParams(window.location.search);

let hideHeader = false;
if (params.get("header_hide") === "true") {
  hideHeader = true;
  document.documentElement?.style?.setProperty(`--header_hide`, `0px`);
} else {
  document.documentElement?.style?.setProperty(`--header_hide`, `55px`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

if (_config.data?.ApplicationNameParameter) {
  document.title = _config?.data?.ApplicationNameParameter;
}
if (_config?.data?.PrimaryColorParameter && _config?.data?.PrimaryColorParameter !== '') {
  const colors = createSwatches({value: _config?.data?.PrimaryColorParameter, valueStop:600})
  colors.forEach((x) => {
    document.documentElement?.style?.setProperty(`--primary-color-${x.stop}`, `hsl(${x.h} ${x.s}% ${x.l}%)`);
  })
} else {
  const colors = createSwatches({value: "#012497", valueStop:600})
  colors.forEach((x) => {
    document.documentElement?.style?.setProperty(`--primary-color-${x.stop}`, `hsl(${x.h} ${x.s}% ${x.l}%)`);
  })
}
if (_config?.data?.SecondaryColorParameter) {
  const colors = createSwatches({value: _config?.data?.SecondaryColorParameter, valueStop:600})
  colors.forEach((x) => {
    document.documentElement?.style?.setProperty(`--secondary-color-${x.stop}`, `hsl(${x.h} ${x.s}% ${x.l}%)`);
  })
} 
// else {
  // const colors = createSwatches({value: "#012497", valueStop:600})
  // colors.forEach((x) => {
  //   document.documentElement?.style?.setProperty(`--secondary-color-${x.stop}`, `hsl(${x.h} ${x.s}% ${x.l}%)`);
  // })
// }



//eslint-disable-next-line
let thissolvesaweirdproblemwithvite = import.meta.env;

root.render(
  <App config={_config?.data} hideHeader={hideHeader}/>
);